// Import model
import { FilterRoomSelectionRequest } from '../models/FilterRoomSelectionRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { RoomSelectionCondition } from '../models/RoomSelectionCondition';
import { RoomSelectionFields } from '../models/RoomSelectionFields';
import { RoomSelectionIndexedFields } from '../models/RoomSelectionIndexedFields';

// Import dependency serializers (for complex types)
import { RoomSelectionConditionSerializer } from './RoomSelectionConditionSerializer';
import { RoomSelectionFieldsSerializer } from './RoomSelectionFieldsSerializer';
import { RoomSelectionIndexedFieldsSerializer } from './RoomSelectionIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterRoomSelectionRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterRoomSelectionRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterRoomSelectionRequest instance
   */
  static deserialize(json: string): FilterRoomSelectionRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterRoomSelectionRequest instance
   */
  static fromObject(obj: any): FilterRoomSelectionRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterRoomSelectionRequest');
    }


    const instance: FilterRoomSelectionRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as RoomSelectionIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as RoomSelectionFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        RoomSelectionConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterRoomSelectionRequest instances
   */
  static deserializeArray(json: string): FilterRoomSelectionRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterRoomSelectionRequest instance to a JSON string
   */
  static serialize(instance: FilterRoomSelectionRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterRoomSelectionRequest instance to a plain object
   */
  static toObject(instance: FilterRoomSelectionRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        RoomSelectionConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterRoomSelectionRequest instances to a JSON string
   */
  static serializeArray(instances: FilterRoomSelectionRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
